export default __webpack_public_path__ + "updating-skills.bcef4e86.gif";